import axios from "./apiClient";

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchAccounts = async (params = {}) => {
  const response = await axios.get(`${apiUrl}/api/admin/accounts`, { params });
  return response.data;
};

export const fetchAccountById = async (accountId) => {
  const response = await axios.get(`${apiUrl}/api/admin/accounts/${accountId}`);
  return response.data;
};

export const createAccount = async (payload) => {
  const response = await axios.post(`${apiUrl}/api/admin/accounts`, payload);
  return response.data;
};

export const updateAccount = async (accountId, payload) => {
  const response = await axios.patch(
    `${apiUrl}/api/admin/accounts/${accountId}`,
    payload,
  );
  return response.data;
};

export const deleteAccount = async (accountId) => {
  const response = await axios.delete(
    `${apiUrl}/api/admin/accounts/${accountId}`,
  );
  return response.data;
};

export const fetchMyProfile = async () => {
  const response = await axios.get(`${apiUrl}/api/admin/accounts/me`);
  return response.data;
};

export const updateMyProfile = async (payload) => {
  const response = await axios.patch(`${apiUrl}/api/admin/accounts/me`, payload);
  return response.data;
};
